import { Routes } from '@angular/router';
import { LoginComponent } from './core';
import { DirectLoginOauthComponent } from './core/auth/direct-login-oauth/direct-login-oauth.component';
import { LoginOauthComponent } from './core/auth/login-oauth-okta/login-oauth-okta.component';
import { LogoutComponent } from './core/auth/logout/logout.component';
import { ResetPasswordComponent } from './core/auth/reset-password/reset-password.component';
import { ViewAsUserAuthComponent } from './core/auth/viewasuser-auth/viewasuser-auth.component';
import { HomepageComponent } from './core/homepage/homepage.component';
import { AuthGuardService } from './services/auth/auth-guard.service';
import { TranslationLoaderResolver } from './services/resolver/translation-loader-resolver';

export const APP_ROUTES: Routes = [
  {
    path: '',
    canActivate: [AuthGuardService],
    component: HomepageComponent,
    pathMatch: 'full',
  },
  {
    path: 'view-as-user',
    component: ViewAsUserAuthComponent,
  },
  {
    path: 'auth/login',
    component: LoginComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'auth/direct-login/:registrationId',
    component: DirectLoginOauthComponent,
  },
  {
    path: 'auth/openauthorizationadmin/:registrationId',
    data: { admin: true },
    component: LoginOauthComponent,
  },
  {
    path: 'auth/openauthorization/:registrationId',
    data: { admin: false },
    component: LoginOauthComponent,
  },
  {
    path: 'auth/saml2admin/:registrationId',
    data: { admin: true },
    component: LoginOauthComponent,
  },
  {
    path: 'auth/saml2/:registrationId',
    data: { admin: false },
    component: LoginOauthComponent,
  },
  {
    path: 'auth/resetpwd',
    component: ResetPasswordComponent,
  },
  {
    path: 'pages',
    resolve: { model: TranslationLoaderResolver },
    loadChildren: () => import('./pages/pages.routes').then((m) => m.PAGES_ROUTES),
  },
  {
    path: 'pages/v26',
    resolve: { model: TranslationLoaderResolver },
    loadChildren: () => import('./pages-v26/pages-v26.routes').then((m) => m.PAGES_V26_ROUTES),
  },
  {
    path: 'restricted',
    resolve: { model: TranslationLoaderResolver },
    loadChildren: () => import('./restricted-pages/restricted-pages.routes').then((m) => m.RESTRICTED_PAGES_ROUTES),
  },
  {
    path: 'configurations',
    outlet: 'configurationOutlet',
    resolve: { model: TranslationLoaderResolver },
    loadChildren: () => import('./configurations-pages/configurations-pages.routes').then((m) => m.CONFIGURATIONS_PAGES_ROUTES),
  },
  {
    path: 'configurations/v26',
    outlet: 'configurationOutlet',
    resolve: { model: TranslationLoaderResolver },
    loadChildren: () => import('./configurations-pages-v26/configurations-pages-v26.routes').then((m) => m.CONFIGURATIONS_PAGES_V26_ROUTES),
  },
  {
    path: 'usecases',
    outlet: 'usecasesOutlet',
    resolve: { model: TranslationLoaderResolver },
    loadChildren: () => import('./use-cases/use-cases.routes').then((m) => m.USE_CASES_ROUTES),
  },
  {
    path: 'tenant-invoice',
    loadChildren: () => import('./pages/interfaces/tenant-invoice/tenant-invoice.routes').then((m) => m.TENANT_INVOICE_ROUTES),
  },
  { path: '**', redirectTo: '/' },
];
